import { Stack, Typography } from "@mui/material";
import { CopyButton, HStack } from "@zfp-akademie-a-s/zfp-design";
import { Configuration } from "Infrastructure/Config/config";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const DevToolsHome = () => {
  const { t } = useResource();

  const rows = [
    { label: t(Resources.DevTools.Home.BranchName), value: Configuration.getBranchName() },
    { label: t(Resources.DevTools.Home.CommitMessage), value: Configuration.getCommitMessage() },
  ];

  return (
    <Stack spacing={Spacing.M}>
      {rows.map(({ label, value }) => (
        <HStack key={label} spacing={Spacing.S} alignItems="center">
          <Typography variant="body2" color="text.secondary" flexShrink={0}>
            {label}
          </Typography>
          <Typography variant="body2" fontFamily="monospace" sx={{ overflowWrap: "anywhere" }}>
            {value}
          </Typography>
          <CopyButton text={value} copyLabel={t(Resources.Common.Copy)} copiedLabel={t(Resources.Common.Copied)} />
        </HStack>
      ))}
    </Stack>
  );
};
